<div class="fullcontainer" >
  <br />
  <br />

  <div class='titleContainer'>
    <h2 class='header' style='color: #006498'>All Accounts</h2>
    <div>
      <!-- <button class='btn btn-info' *ngIf='this.viewActiveAccounts && !viewProspects' (click)='this.viewActiveAccounts = false'><i class="fas fa-envelope"></i>View Inactive Accounts</button>&nbsp;
      <button class='btn btn-info' *ngIf='!this.viewActiveAccounts && !viewProspects' (click)='this.viewActiveAccounts = true'><i class="fas fa-envelope"></i>View Active Accounts</button>&nbsp;
      <button class='btn btn-info' *ngIf='!this.viewProspects' (click)='this.viewProspects = true'><i class="fas fa-envelope"></i>View Prospects</button>&nbsp;
      <button class='btn btn-info' *ngIf='this.viewProspects' (click)='this.viewProspects = false'><i class="fas fa-envelope"></i>View Accounts</button>&nbsp; -->
      <button class='btn btn-secondary' (click)='onGenerateLink($event)'><i class="fas fa-envelope"></i> Generate new customer link</button>&nbsp;
      <button class='btn btn-secondary' routerLink='/accounts/new'><i class="fas fa-plus"></i> New</button>&nbsp;
    </div>
  </div>
  <br />
  <br />
  <br />

  <div>

    <button class='btn btn-secondary accountHover' (click)='this.accountTypeFilter = "all"' [class.accountHoverActive]='this.accountTypeFilter === "all"'>All Accounts</button>&nbsp;
    <button class='btn btn-secondary customerHover' (click)='this.accountTypeFilter = "customer"' [class.customerHoverActive]='this.accountTypeFilter === "customer"'>All Customers</button>&nbsp;
    <button class='btn btn-secondary prospectHover' (click)='this.accountTypeFilter = "prospect"' [class.prospectHoverActive]='this.accountTypeFilter === "prospect"'>All Prospects</button>&nbsp;
    <button class='btn btn-secondary depotHover' (click)='this.accountTypeFilter = "depot"' [class.depotHoverActive]='this.accountTypeFilter === "depot"'>All Depots</button>&nbsp;
    <button class='btn btn-secondary tipHover' (click)='this.accountTypeFilter = "tip"' [class.tipHoverActive]='this.accountTypeFilter === "tip"'>All Tips</button>&nbsp;
    <button class='btn btn-secondary inactiveHover' (click)='this.accountTypeFilter = "inactive"' [class.inactiveHoverActive]='this.accountTypeFilter === "inactive"'>Inactive Accounts</button>&nbsp;
  </div>
  <br />
  <br />


  <!-- <app-inactive-accounts *ngIf='!viewActiveAccounts && !viewProspects'></app-inactive-accounts> -->
  @if (this.accountTypeFilter === "all") {
    <app-all-accounts-section></app-all-accounts-section>
  }
  @if (this.accountTypeFilter === "customer") {
    <app-active-accounts></app-active-accounts>
  }
  @if (this.accountTypeFilter === "prospect") {
    <app-prospects></app-prospects>
  }
  @if (this.accountTypeFilter === "depot") {
    <app-depot-section></app-depot-section>
  }
  @if (this.accountTypeFilter === "tip") {
    <app-tips-section></app-tips-section>
  }
  @if (this.accountTypeFilter === "inactive") {
    <app-inactive-accounts></app-inactive-accounts>
  }